<template>
  <v-container>
    <v-row align="center" justify="center">
      <v-col cols="12" md="5">
        <v-card class="pa-2 card-radius">
          <v-card-title class="py-1 my-1">
            <span>Change your password</span>
          </v-card-title>
          <v-card-text class="my-1 py-0">
            <v-container class="py-0 my-0">
              <v-row>
                <v-col cols="12" class="my-1 py-0">
                  <v-text-field
                    v-model="oldPassword"
                    :append-icon="showOldPassword ? 'visibility' : 'visibility_off'"
                    :type="showOldPassword ? 'text' : 'password'"
                    label="Old password"
                    :error-messages="errors"
                    @click:append="showOldPassword = !showOldPassword"
                  />
                </v-col>
                <v-col cols="12" class="my-1 py-0">
                  <v-text-field
                    v-model="newPassword"
                    :append-icon="showNewPassword? 'visibility' : 'visibility_off'"
                    :type="showNewPassword ? 'text' : 'password'"
                    label="New password"
                    :error-messages="errors"
                    @click:append="showNewPassword = !showNewPassword"
                  />
                </v-col>
                <v-col cols="12" class="my-1 py-0">
                  <v-text-field
                    v-model="newPasswordRepeat"
                    :append-icon="showNewPasswordRepeat? 'visibility' : 'visibility_off'"
                    :type="showNewPasswordRepeat ? 'text' : 'password'"
                    label="New password repeated"
                    :error-messages="errors"
                    @click:append="showNewPasswordRepeat = !showNewPasswordRepeat"
                  />
                  <v-alert v-if="formError && formError.oldPassword" type="warning">
                      Old password incorrect.
                      <router-link class="white--text font-weight-bold" to="/forgot-password">
                        Forgot Password?
                      </router-link>
                    </v-alert>
                  <v-alert v-if="formError && formError.newPassword2" type="warning">
                    New passwords don't match
                  </v-alert>
                  <v-alert v-if="success" type="success">
                    Password updated
                  </v-alert>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions class="pt-0 mt-0">
            <v-spacer></v-spacer>
            <v-btn color="secondary" :loading="saving" rounded @click="save()">CHANGE PASSWORD</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import { CHANGE_PASSWORD_MUTATION } from '../../constants/graphql/account/resetPassword'

  export default {
    name: 'ResetPassword',
    data() { 
      return { oldPassword: '',
        newPassword: '',
        newPasswordRepeat: '',
        saving: false,
        success: false,
        formError: [],
        showOldPassword: false,
        showNewPassword: false,
        showNewPasswordRepeat: false,
      }
    },
    methods: {
      save() {
        this.$apollo.mutate({
          mutation: CHANGE_PASSWORD_MUTATION,
          variables: {
            oldPassword: this.oldPassword, 
            newPassword1: this.newPassword, 
            newPassword2: this.newPasswordRepeat
          },
        }).then((response) => {
          this.success = response.data.passwordChange.success
          if(response.data.passwordChange.success == false) {
            this.formError = response.data.passwordChange.errors
            this.formErrorShow = true
          } else {
            this.formError = []
          }
        })
      },
    },
  }
</script>
